var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggleoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 47,
    viewBox: "0 0 104 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 47,
    rx: 23.5,
    fill: "#DD596A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 23,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5701 23.3636C59.5701 24.9943 59.2718 26.3963 58.6752 27.5696C58.0786 28.7379 57.2608 29.6378 56.2217 30.2692C55.1876 30.8956 54.0119 31.2088 52.6944 31.2088C51.3719 31.2088 50.1912 30.8956 49.1521 30.2692C48.118 29.6378 47.3027 28.7354 46.7061 27.5621C46.1095 26.3888 45.8112 24.9893 45.8112 23.3636C45.8112 21.733 46.1095 20.3335 46.7061 19.1651C47.3027 17.9918 48.118 17.092 49.1521 16.4656C50.1912 15.8342 51.3719 15.5185 52.6944 15.5185C54.0119 15.5185 55.1876 15.8342 56.2217 16.4656C57.2608 17.092 58.0786 17.9918 58.6752 19.1651C59.2718 20.3335 59.5701 21.733 59.5701 23.3636ZM57.2881 23.3636C57.2881 22.1207 57.0868 21.0742 56.6841 20.2241C56.2864 19.369 55.7395 18.7227 55.0435 18.2852C54.3524 17.8427 53.5694 17.6214 52.6944 17.6214C51.8144 17.6214 51.0289 17.8427 50.3378 18.2852C49.6468 18.7227 49.0999 19.369 48.6972 20.2241C48.2995 21.0742 48.1006 22.1207 48.1006 23.3636C48.1006 24.6065 48.2995 25.6555 48.6972 26.5107C49.0999 27.3608 49.6468 28.0071 50.3378 28.4496C51.0289 28.8871 51.8144 29.1058 52.6944 29.1058C53.5694 29.1058 54.3524 28.8871 55.0435 28.4496C55.7395 28.0071 56.2864 27.3608 56.6841 26.5107C57.0868 25.6555 57.2881 24.6065 57.2881 23.3636ZM62.443 31V15.7273H71.9139V17.7109H64.7474V22.3643H71.2353V24.3406H64.7474V31H62.443ZM74.7477 31V15.7273H84.2186V17.7109H77.0521V22.3643H83.54V24.3406H77.0521V31H74.7477Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleoff);
export default __webpack_public_path__ + "static/media/toggleoff.554c24b5d9ac66d6dcd5c1b03b872eb1.svg";
export { ForwardRef as ReactComponent };